<div class="d-flex flex-column nxt-p-8">
  <div class="d-flex flex-column mb-3">
    <h2 class="font-weight-bold nxt-font-20 mb-3">Set password required to download/schedule report</h2>
    <ul class="pl-3 mb-0">
      <li class="nxt-font-14">For your security, all downloaded or scheduled reports must be password-protected. Please go to your Profile page and set your secure file password now.</li>
      <li class="mb-0 nxt-font-14">Once set, all your downloaded files will be protected with that password and will be required to open them.</li>
    </ul>
  </div>
  <div class="d-flex justify-content-end nxt-mt-24 nxt-gap-20">
    <button type="button" class="btn btn-secondary mr-2" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="goToProfile()">Go to profile page</button>
  </div>
</div>
